import React, { useEffect, useState } from "react";
import { FiEye, FiEyeOff, FiSearch } from "react-icons/fi";
import "./addHelpTeam.css";
import LoadingPage from "../Loading/loading";
import {
  deleteHelpTeam,
  getHelpTeam,
  updateHelpTeam,
} from "../../api/helpTeam";
import { proxy } from "../../config";
import { useNavigate } from "react-router-dom";
import { changePasswordBySuper } from "../../api/admins";

const HelpTeamComponent = (props) => {
  const navigate = useNavigate();
  const [helpTeams, setHelpTeams] = useState(null);
  const [idUpdate, setIdUpdate] = useState("");
  const [idPassword, setIdPassword] = useState("");
  const [id, setId] = useState("");
  const [image, setImage] = useState(null);

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formDataPassword, setFormDataPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormDataPassword((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

   const handleChangeData = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    e.target.setCustomValidity("");
    setImage(e.target.files[0]);
  };

  useEffect(() => {
    setHelpTeams(null);
    getHelpTeam().then((result) => {
      setHelpTeams(result.data.response);
    });
  }, []);

  const deleteHelp = (id) => {
    deleteHelpTeam(id).then((result) => {
      setHelpTeams(helpTeams.filter((helpTeam) => helpTeam._id !== id));
    });
  };

  const update = () => {
    setLoading(true);
    const formBack = new FormData();
    formBack.append("image", image);
    formBack.append("name", formData.name);
    formBack.append("strength", formData.strength);
    formBack.append("phone", formData.phone);
    formBack.append("whatsapp", formData.whatsapp);
    updateHelpTeam(formData._id, formBack).then((result) => {
      getHelpTeam(props.user).then((result) => {
        setHelpTeams(result.data.response);
        setIdUpdate("");
        setFormData(null);
        setLoading(false);
      });
    });
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (e) => {
    if (e.nativeEvent.submitter.name === "change") {
      e.preventDefault();
      if (formDataPassword.newPassword !== formDataPassword.confirmPassword) {
        alert("password is not match");
      } else {
        changePasswordBySuper(idPassword, formDataPassword.newPassword).then(
          (result) => {
            setFormDataPassword({
              newPassword: "",
              confirmPassword: "",
            });
            setIdPassword("");
          },
        );
      }
    } else {
      setFormDataPassword({
        newPassword: "",
        confirmPassword: "",
      });
      setIdPassword("");
    }
  };

  return (
    <>
      {helpTeams === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="card-cards">
            {helpTeams?.map((helpTeam) => (
              <div key={helpTeam.id} className={`card-card`}>
                {idUpdate === helpTeam._id ? (
                  <div style={{ width: "100%" }}>
                    {image === null ? (
                      <img
                        src={`${proxy}/${formData.image}`}
                        alt="Uploaded"
                        style={{ maxWidth: "100%", marginTop: "10px" }}
                      />
                    ) : (
                      <img
                        src={URL.createObjectURL(image)}
                        alt="Uploaded"
                        style={{ maxWidth: "100%", marginTop: "10px" }}
                      />
                    )}
                    <div className="form-group">
                      <label htmlFor="image">Image</label>
                      <input
                        type="file"
                        id="image"
                        name="image"
                        onChange={handleFileChange}
                        accept="image/*"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Image is required")
                        }
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="name">Name</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChangeData}
                        placeholder="Enter name"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Name is required")
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="strength">Strength</label>
                      <input
                        type="text"
                        id="strength"
                        name="strength"
                        value={formData.strength}
                        onChange={handleChangeData}
                        placeholder="Enter strength"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Strength is required")
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone">Phone</label>
                      <input
                        type="text"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChangeData}
                        placeholder="Enter phone"
                        maxLength="11"
                        pattern="^01[0-2,5]\d{1,8}$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("Phone is required")
                        }
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="whatsapp">WhatsApp</label>
                      <input
                        type="text"
                        id="whatsapp"
                        name="whatsapp"
                        value={formData.whatsapp}
                        onChange={handleChangeData}
                        placeholder="Enter whatsapp"
                        maxLength="11"
                        pattern="^01[0-2,5]\d{1,8}$"
                        required
                        onInvalid={(e) =>
                          e.target.setCustomValidity("whatsapp is required")
                        }
                      />
                    </div>

                    {loading ? (
                      <div
                        style={{
                          width: "100%",
                          justifyContent: "center",
                          display: "flex",
                        }}
                      >
                        <div className="spinner"></div>
                      </div>
                    ) : (
                      <div className="card-info">
                        <div className="card-actions">
                          <button
                            onClick={() => {
                              setFormData(null);
                              setIdUpdate("");
                            }}
                            className="action-btn remove-btn"
                          >
                            No
                          </button>
                        </div>
                        <div className="card-actions">
                          <button
                            onClick={() => {
                              update();
                            }}
                            className="action-btn accept-btn"
                          >
                            Update this team
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="card-info">
                    <div>
                      <img
                        className="image-slider"
                        height={"100px"}
                        src={`${proxy}/${helpTeam.image}`}
                      />
                      <p className="line">
                        <span className="label">Name:</span> {helpTeam.name}
                      </p>
                      <p className="line">
                        <span className="label">Strength:</span>{" "}
                        {helpTeam.strength}
                      </p>
                      <p className="line">
                        <span className="label">Phone:</span> {helpTeam.phone}
                      </p>
                      <p className="line">
                        <span className="label">WhatsApp:</span>{" "}
                        {helpTeam.whatsapp}
                      </p>
                      <p className="line">
                        <span className="label">No. of team:</span>{" "}
                        {helpTeam?.number_team}
                      </p>
                      {id === helpTeam._id && (
                        <div
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "5px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className="line">
                            Are you sure you want to delete this free brokers
                            discount?{" "}
                          </p>
                          <div className="card-info">
                            <div className="card-actions">
                              <button
                                onClick={() => {
                                  setId("");
                                }}
                                className="action-btn accept-btn"
                              >
                                No
                              </button>
                            </div>
                            <div className="card-actions">
                              <button
                                onClick={() => {
                                  deleteHelp(helpTeam._id);
                                }}
                                className="action-btn remove-btn"
                              >
                                Yes
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      {idPassword === helpTeam._id && (
                        <form onSubmit={handleSubmit}>
                          <div className="form-group">
                            <label htmlFor="newPassword">New password</label>
                            <div className="search-input-wrapper">
                              <input
                                type={showNewPassword ? "text" : "password"}
                                id="newPassword"
                                name="newPassword"
                                value={formDataPassword.newPassword}
                                onChange={handleChange}
                                placeholder="Enter new password"
                                style={{ paddingRight: "40px" }}
                              />
                              <button
                                type="button"
                                onClick={toggleNewPasswordVisibility}
                                className="password-toggle"
                                aria-label={
                                  showNewPassword
                                    ? "Hide password"
                                    : "Show password"
                                }
                              >
                                {showNewPassword ? <FiEyeOff /> : <FiEye />}
                              </button>
                            </div>
                          </div>

                          <div className="form-group">
                            <label htmlFor="confirmPassword">
                              Confirm new password
                            </label>
                            <div className="search-input-wrapper">
                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                id="confirmPassword"
                                name="confirmPassword"
                                value={formDataPassword.confirmPassword}
                                onChange={handleChange}
                                placeholder="Enter confirm new password"
                                style={{ paddingRight: "40px" }}
                              />
                              <button
                                type="button"
                                onClick={toggleConfirmPasswordVisibility}
                                className="password-toggle"
                                aria-label={
                                  showConfirmPassword
                                    ? "Hide password"
                                    : "Show password"
                                }
                              >
                                {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                              </button>
                            </div>
                          </div>

                          {loading ? (
                            <div
                              style={{
                                width: "100%",
                                justifyContent: "center",
                                display: "flex",
                              }}
                            >
                              <div className="spinner"></div>
                            </div>
                          ) : (
                            <>
                              <button
                                type="submit"
                                name="change"
                                className="submit-button ban-btn"
                              >
                                Change password
                              </button>
                              <button
                                type="submit"
                                name="cancel"
                                className="submit-button ban-btn"
                              >
                                Cancel
                              </button>
                            </>
                          )}
                        </form>
                      )}
                      {props.isSuper && (
                        <>
                          {id !== helpTeam._id &&
                            idUpdate !== helpTeam._id &&
                            idPassword !== helpTeam._id && (
                              <div className="card-actions">
                                <button
                                  onClick={() => {
                                    navigate(`/assign/${helpTeam._id}`);
                                  }}
                                  className="action-btn accept-btn"
                                >
                                  Assign
                                </button>
                                <button
                                  onClick={() => {
                                    navigate(`/team/${helpTeam._id}`);
                                  }}
                                  className="action-btn accept-btn"
                                >
                                  Team
                                </button>
                                <button
                                  onClick={() => {
                                    setIdPassword(helpTeam._id);
                                  }}
                                  className="action-btn ban-btn"
                                >
                                  Change password
                                </button>
                                <button
                                  onClick={() => {
                                    setIdUpdate(helpTeam._id);
                                    setFormData(helpTeam);
                                  }}
                                  className="action-btn ban-btn"
                                >
                                  Edit
                                </button>
                                <button
                                  onClick={() => {
                                    setId(helpTeam._id);
                                  }}
                                  className="action-btn remove-btn"
                                >
                                  Delete
                                </button>
                              </div>
                            )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default HelpTeamComponent;
